import { Urls } from "@share/constants";
import { axiosInstance, axiosInstanceB2B, getHeaders } from "@share/utils";
import { AxiosPromise } from "axios";
import { ICompanyBookingsParams } from "../common-types/company-bookings";
import { isEmpty } from "lodash";

export const CompanyBookingsAPI = {
    getCompanyBookings(params: ICompanyBookingsParams): AxiosPromise<any> {
        const { orderBy, sortOrder, page, pageSize, bookingId, propertyName, leadName, bookingType, status } = params;
  
        const bookingIdParam = `${bookingId ? `&bookingId=${bookingId}` : ''}`;
        const propertyNameParam = `${propertyName ? `&propertyName=${propertyName}` : ''}`;
        const leadNameParam = `${leadName ? `&leadName=${leadName}` : ''}`;
        const bookingTypeParam = `${bookingType ? `&bookingType=${bookingType}` : ''}`;
        const statusParam = `${status ? `&status=${status}` : ''}`;
  
        const orderParam = `${(orderBy && sortOrder) ? `&orderBy=${orderBy}` : ''}${sortOrder ? `&sortOrder=${sortOrder}` : ''}`;
        const queryString = `?page=${page}&results=${pageSize}${bookingTypeParam}${orderParam}${bookingIdParam}${propertyNameParam}${leadNameParam}${statusParam}`;
  
        return axiosInstanceB2B.get(`${Urls.getCompanyBookings}${queryString}`, {
            ...getHeaders(),
        });
    },

    searchByText(queryString: string, type?: string): AxiosPromise<any> {
        const params: any = { queryString };
        if (!isEmpty(type)) {
          params.bookingType = type;
        }
        return axiosInstance.get(Urls.companyBookingsSearchText, {
          params,
          ...getHeaders(),
        });
      },
}